import axios from "axios";
import React, { useEffect, useState } from "react";

import "./DashBoard.css";

import { ApiConnectionString } from "../../../constants/ApiConntection";
import MembershipModal from "../modals/MemershipModal";

export default function Overview({ profile, user }) {
  const [isVisible, setIsVisible] = useState(false);
  const [acceptingNewClients, setAcceptingNewClients] = useState(false);

  // const [range, setRange] = useState("7d");

  const [enquiriesCount, setEnquiriesCount] = useState(null);
  const [profileViewsCount, setProfileViewsCount] = useState(null);

  const [membershipModal, setMembershipModal] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);

  const cancelModal = () => {
    setMembershipModal(false);
  };

  const openMembershipModal = () => {
    setMembershipModal(true);
  };

  useEffect(() => {
    if (!profile) return;

    if (!profile.isVerified) {
      setIsVisible(false);
      setAcceptingNewClients(false);
      setMembershipModal(false);
      return;
    }

    if (profile.live == false) {
      setMembershipModal(true);
    }

    setIsVisible(profile.profileVisable);
    setAcceptingNewClients(profile.acceptingNewClients);
  }, [profile]);

  const toggleVisibility = async () => {
    if (!profile?.isVerified || !user?.token) return;

    const prev = isVisible;
    setIsVisible(!prev);

    try {
      const res = await axios.put(
        `${ApiConnectionString}/api/counsellorProfile/visibility`,
        null,
        { headers: { Authorization: `Bearer ${user.token}` } },
      );

      if (typeof res.data === "boolean") {
        setIsVisible(res.data);
      }
    } catch {
      setIsVisible(prev);
    }
  };

  const toggleAccepting = async () => {
    if (!profile?.isVerified || !user?.token) return;

    const prev = acceptingNewClients;
    setAcceptingNewClients(!prev);

    try {
      const res = await axios.put(
        `${ApiConnectionString}/api/counsellorProfile/Accepting`,
        null,
        { headers: { Authorization: `Bearer ${user.token}` } },
      );

      if (typeof res.data === "boolean") {
        setAcceptingNewClients(res.data);
      } else {
        setAcceptingNewClients(prev);
      }
    } catch {
      setAcceptingNewClients(prev);
    }
  };

  // Period filtering temporarily disabled
  /*
  const days = useMemo(() => {
    if (range === "7d") return 7;
    if (range === "30d") return 30;
    if (range === "90d") return 90;
    return 7;
  }, [range]);

  const rangeText = useMemo(() => {
    if (range === "7d") return "Showing activity from the last 7 days";
    if (range === "30d") return "Showing activity from the last 30 days";
    if (range === "90d") return "Showing activity from the last 90 days";
    return "Showing activity from the last 7 days";
  }, [range]);
  */

  const fetchData = async () => {
    if (!user?.token) return;

    try {
      const authConfig = {
        headers: { Authorization: `Bearer ${user.token}` },
      };

      const [profileViewsResponse, enquiriesResponse] = await Promise.all([
        axios.get(`${ApiConnectionString}/api/ProfileViews`, {
          // params: { days },
          ...authConfig,
        }),

        axios.get(`${ApiConnectionString}/api/EnquiryCount`, {
          // params: { days },
          ...authConfig,
        }),
      ]);

      setProfileViewsCount(profileViewsResponse.data || 0);
      setEnquiriesCount(enquiriesResponse.data || 0);
    } catch {
      setProfileViewsCount(0);
      setEnquiriesCount(0);
    }
  };

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user?.token]);

  if (!profile) return <div />;

  const visibilityStatusText = !profile.isVerified
    ? "Your profile will appear in the directory once your account is approved."
    : isVisible
      ? "Your profile is currently visible in the directory."
      : "Your profile is currently hidden from the directory.";

  const acceptingStatusText = !profile.isVerified
    ? "Clients will be able to send enquiries once your account is approved."
    : acceptingNewClients
      ? "Your profile shows that you are accepting new clients."
      : "Your profile shows that you are not currently accepting new clients.";

  const profileViewsHelper =
    profileViewsCount === null
      ? "Loading profile views..."
      : profileViewsCount === 0
        ? "No profile views yet."
        : "Total profile views.";

  const enquiriesHelper =
    enquiriesCount === null
      ? "Loading enquiries..."
      : enquiriesCount === 0
        ? "No enquiries yet. When a client contacts you, they will appear here."
        : "Total enquiries received.";

  const showMembershipUpsell = profile.isVerified && profile.live == false;

  return (
    <div>
      {membershipModal && profile.isVerified && profile.live == false && (
        <MembershipModal value={profile} cancelModal={cancelModal} />
      )}

      <div className="db-shell">
        <div className="db-wrap">
          <div className="db-card">

            {!profile.isVerified && (
              <div className="db-review-banner">
                <div className="db-review-title">Account under review</div>
                <div className="db-review-text">
                  Your account is currently under review. This usually takes 1
                  to 3 days to be reviewed. After it is approved, your account
                  will go live.
                </div>
              </div>
            )}

            {showMembershipUpsell && (
              <div className="db-review-banner">
                <div className="db-review-title">Your profile is not live</div>

                <div className="db-review-text">
                  Subscribe to make your profile visible in the directory. You
                  can open the payment options any time.
                </div>

                <div className="mt-3">
                  <button
                    className="db-btn db-btn-primary"
                    type="button"
                    onClick={openMembershipModal}
                  >
                    Make profile live
                  </button>

                  <button
                    className="db-btn db-btn-ghost ms-2"
                    type="button"
                    onClick={openMembershipModal}
                  >
                    View plans
                  </button>
                </div>
              </div>
            )}

            <div className="db-main-head">
              <div>
                <h1 className="db-h1">Overview</h1>

                {/* Period text temporarily disabled */}
                {/* <div className="db-subtle">{rangeText}</div> */}
              </div>

              {/* Period dropdown temporarily disabled */}
              {/*
              <div className="db-actions">
                <select
                  className="db-select"
                  value={range}
                  onChange={(e) => setRange(e.target.value)}
                >
                  <option value="7d">Last 7 days</option>
                  <option value="30d">Last 30 days</option>
                  <option value="90d">Last 90 days</option>
                </select>
              </div>
              */}
            </div>

            <div className="db-stats">
              <div className="db-stat">
                <div className="db-stat-label">Profile views</div>

                <div className="db-stat-value">
                  {profileViewsCount === null
                    ? "Loading..."
                    : profileViewsCount}
                </div>

                <div className="text-muted">{profileViewsHelper}</div>
              </div>

              <div className="db-stat">
                <div className="db-stat-label">Enquiries</div>

                <div className="db-stat-value">
                  {enquiriesCount === null ? "Loading..." : enquiriesCount}
                </div>

                <div className="text-muted">{enquiriesHelper}</div>
              </div>
            </div>

            <div className="db-divider" />

            <div className="db-toggle-row">
              <div className="db-toggle-text">
                <div className="db-toggle-title">Directory visibility</div>

                <div className="db-toggle-sub">
                  Control if clients can find you
                </div>

                <div className="db-toggle-status">{visibilityStatusText}</div>
              </div>

              <label className="db-switch">
                <input
                  type="checkbox"
                  checked={isVisible}
                  disabled={!profile.isVerified}
                  onChange={toggleVisibility}
                />
              </label>
            </div>

            <div className="db-toggle-row mt-2">
              <div className="db-toggle-text">
                <div className="db-toggle-title">Accepting new clients</div>

                <div className="db-toggle-sub">
                  Control if clients can send enquiries
                </div>

                <div className="db-toggle-status">{acceptingStatusText}</div>
              </div>

              <label className="db-switch">
                <input
                  type="checkbox"
                  checked={acceptingNewClients}
                  disabled={!profile.isVerified}
                  onChange={toggleAccepting}
                />
              </label>
            </div>

            <div className="db-action mt-4">

              {showMembershipUpsell && (
                <button
                  className="db-btn db-btn-primary"
                  type="button"
                  onClick={openMembershipModal}
                >
                  Make profile live
                </button>
              )}

              {profile.live && (
                <>
                  <button
                    className="db-btn db-btn-primary"
                    type="button"
                    onClick={() =>
                      window.open(
                        `https://neurotherapydirectory.com/therapist/${profile.slug}`,
                        "_blank",
                      )
                    }
                  >
                    Preview profile
                  </button>

                  <button
                    className="db-btn db-btn-ghost"
                    type="button"
                    onClick={async () => {
                      const link = `https://neurotherapydirectory.com/therapist/${profile.slug}`;

                      await navigator.clipboard.writeText(link);

                      setLinkCopied(true);

                      setTimeout(() => {
                        setLinkCopied(false);
                      }, 2000);
                    }}
                  >
                    {linkCopied ? "Copied" : "Share link"}
                  </button>
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}